export default __webpack_public_path__ + "static/media/Simple Colored Photo Framed Love Themed Minimalist Movie Poster.686edb94.png";